import React from "react";

const About = () => {
  return (
    <div
      name="about"
      className="w-full h-screen bg-gradient-to-b from-gray-800 to-black text-white"
    >
      <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full">
        <div className="pb-8">
          <p className="text-4xl font-bold inline border-b-4 border-gray-500">
            About Me
          </p>
        </div>
        <p className="text-xl mt-4">
          Hi there! I'm a 17-year-old programmer who's been diving into the
          world of coding for the past three years. I love creating both games
          and websites, and my passion truly shines in making cute multiplayer
          games that bring people together.
        </p>
        <br />
        <p className="text-xl">
          <strong>What I Do:</strong> I love crafting adorable, fun multiplayer
          games. There's something magical about designing experiences that make
          people smile and connect with each other. I primarily use Unity and
          Godot, which let me work on both 2D and 3D projects, adding a lot of
          variety to what I create.
        </p>
        <br />
        <p className="text-xl">
          <strong>Dreams and Aspirations:</strong> Even though I adore making
          cute games, I've got a big dream of developing an awesome racing game
          one day. The excitement and challenge of racing games have always
          fascinated me, and I'd love to bring that thrill to life in my own
          unique way.
        </p>
        <br />
        <p className="text-xl">
          <strong>My Web Dev Side:</strong> Besides game development, I also
          enjoy building websites. It's pretty cool to create user-friendly,
          good-looking sites that people enjoy using. Combining my skills in
          game and web development helps me build complete digital experiences,
          from fun games to handy websites.
        </p>
        <br />
        <p className="text-xl">
          <strong>Let’s Connect!</strong> Thanks for stopping by my site! Check
          out my projects to see what I've been up to. If you're interested in
          working together or just want to chat about game development, feel
          free to reach out. I'm always happy to connect with fellow developers
          and enthusiasts.
        </p>
      </div>
    </div>
  );
};

export default About;
